<template>
  <v-app standalone :class="[$root.isRTL ? 'RLT' : '']">
    <transition name="slide-right">
      <div :class="['mobileMenu', $root.activeMobileMenu ? 'activeMenu' : '']">
        <SubMenu></SubMenu>
      </div>
    </transition>
    <v-navigation-drawer v-model="$root.activeSubMenu" light :class="[$root.device.isTablet ? 'tabletMenu' : '', $root.isRTL ? 'navigation-drawer--right' : '', 'elevation-10']" style="padding: 0px; margin: 0px; z-index: 200;">
      
    <!--<v-navigation-drawer v-model="$root.activeSubMenu" light :class="[$root.isRTL ? 'navigation-drawer--right' : '', 'elevation-10']" style="padding: 0px; margin: 0px; z-index: 200;">-->
      <div style="overflow: hidden;">
        <v-toolbar style="background-color:#3A2D01; height: 200px;">
          <v-layout row wrap style="color:#fff; padding: 20px;">
            <v-flex md12 sm12>
              <b>{{title}}</b>
            </v-flex>
            <v-flex md12 sm12>
              &nbsp;
            </v-flex>
            <v-flex md6 sm6>
              <div style="text-align: right; width: 100%;">שם פרויקט:</div>
            </v-flex>
            <v-flex md6 sm6>
              <b style="text-align: left;">{{projectName}}</b>
            </v-flex>
            <v-flex md6 sm6>
              <div style="text-align: right; width: 100%;">סטטוס פרויקט:</div>
            </v-flex>
            <v-flex md6 sm6>
              <b style="text-align: left;">{{getStatus()}}</b>
            </v-flex>
            <v-flex md10 sm10>
              <a target="_blank" :href="planLink" class="btnPlans">
                <v-layout>
                  <v-flex xs1>
                  </v-flex>
                  <v-flex xs2>
                    <i class="material-icons icon">picture_as_pdf</i>
                  </v-flex>
                  <v-flex xs8>
                    <div style="font-weight: bold;">תוכנית בנייה</div>
                  </v-flex>
                </v-layout>
              </a>
            </v-flex>
          </v-layout>
        </v-toolbar>
        <v-navigation-drawer v-model="$root.activeSubMenu" right :class="['submenu', $root.device.isTablet ? 'tabletMenu' : '']" style="overflow: hidden; margin-bottom: 50px;">
          <v-list v-if="$root.device.isTablet">
            <v-list-tile @click.native="$root.goto('Diaries');">
              <v-list-tile-content>
                <v-list-tile-title style="text-align: right!important; margin: 10px;">חזרה</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <i class="material-icons" style="cursor: pointer;" @click="$root.goto('Diaries')" v-tooltip:bottom="{ html: 'הורדה' }">close</i>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-list class="listScroll">
              <v-list-tile v-for="page in pages" :class="['subMenuItem', $root.activeDiaryPage.Date == page.Date ? 'active' : '']" @click.native="dayClick(page)">
                <v-list-tile-content>
                  <v-list-tile-title style="text-align: right!important; margin: 10px;">{{ page.Date }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <i class="material-icons" v-if="page && page.PageKey" style="cursor: pointer;" @click="sendMail(page, $event)" v-tooltip:bottom="{ html: 'שליחה' }">mail</i>
                  <i class="material-icons" v-if="page && page.PageKey" style="cursor: pointer;" @click="downloadPage(page, $event)" v-tooltip:bottom="{ html: 'הורדה' }">file_download</i>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-navigation-drawer>
    </div>
    </v-navigation-drawer>
    <v-container fluid style="z-index: 100;">
      <v-card :class="[$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']">
        <v-toolbar dark color="primary" class="fullToolbar">
          <v-toolbar-title v-if="$root.device.isMobile" class="white--text" style="font-size: 30px; text-align: right; width: 200px;">
            <i class="material-icons icon">assignment</i>{{title}}
          </v-toolbar-title>
          <div v-else class="divDiary">
            <img class="logoDiary" src="../assets/yomanet.png" />
            <div class="diaryTitle">{{title}}</div>
          </div>
          <v-layout v-if="!$root.device.isMobile" @click="advanceSearch=true" style="width: 120px; cursor: pointer; color: #fff;">
            <v-flex xs1>
              <i class="material-icons icon">search</i>
            </v-flex>
            <v-flex xs3>
              <div style="font-weight: bold; width: 100px;">חיפוש מתקדם</div>
            </v-flex>
          </v-layout>
          <v-spacer v-if="!$root.device.isMobile"></v-spacer>
          <v-text-field v-if="!$root.device.isMobile" dark prepend-icon="search" single-line style="padding-top: 20px;" v-model="txtSearch"></v-text-field>
          <v-icon v-else @click="$root.activeMobileMenu=true" class="btnIcon mr-2 ml-2">menu</v-icon>
        </v-toolbar>
        <div v-if="$root.device.isMobile">
          <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
            <tr class="trPrint trHeader">
              <th>
                <div>שם פרויקט: <b>{{projectName}}</b></div>
                <div>סטטוס פרויקט: <b>{{getStatus()}}</b></div>
                <div style="max-width: 150px;">
                  <a v-if="planLink" target="_blank" :href="planLink" class="btnPlans">
                    <v-layout>
                      <v-flex xs3>
                        <i class="material-icons icon">picture_as_pdf</i>
                      </v-flex>
                      <v-flex xs9>
                        <div style="font-weight: bold;">תוכניות בנייה</div>
                      </v-flex>
                    </v-layout>
                  </a>
                </div>
              </th>
              <th>
                <v-layout @click="advanceSearch=true">
                  <v-flex xs4>
                    <i class="material-icons icon">search</i>
                  </v-flex>
                  <v-flex xs8>
                    <div style="font-weight: bold;">חיפוש</div>
                  </v-flex>
                </v-layout>
              </th>
            </tr>
          </table>
          <DiaryPageMobile v-if="project" :pages="pages" :page="$root.activeDiaryPage" :location="project.Location" :pageKey="$root.activeDiaryPage.PageKey" :key="$root.activeDiaryPage.PageKey"></DiaryPageMobile>
        </div>
        <div v-else class="divScroll">
          <DiaryPage v-if="project" :txtSearch="txtSearch" :page="$root.activeDiaryPage" :location="project.Location" :pageKey="$root.activeDiaryPage.PageKey" :key="$root.activeDiaryPage.PageKey"></DiaryPage>
        </div>
      </v-card>
    </v-container>
    <v-snackbar :timeout="$root.alert.timeout" :top="$root.alert.isTop" v-model="$root.alert.isShow">{{ $root.alert.message }}</v-snackbar>
    <PopupConfim></PopupConfim>
    <img id="imgYoman" style="display: none;" src="../assets/yomanet.png" />
    <div class="advanceSearch elevation-10" v-show="advanceSearch">
      <v-layout style="padding: 10px;background-color: #3A2D01; color: #fff;">
        <v-flex xs1>
          <i class="material-icons icon" @click="advanceSearch=false">close</i>
        </v-flex>
        <v-flex xs11>
          <div style="font-weight: bold;">חיפוש מתקדם</div>
        </v-flex>
      </v-layout>
      <v-layout style="padding: 10px;">
        <v-flex xs11>
          <v-text-field dark prepend-icon="search" single-line v-model="txtAdvanceSearch"></v-text-field>
        </v-flex>
        <v-flex xs1>
        </v-flex>
      </v-layout>
      <v-layout style="padding: 10px; height: calc(100% - 200px); overflow-y: scroll;" v-if="hasData">
        <v-flex xs12>
          <div v-for="(note,index) in advanceSearchNotes" style="cursor: pointer;" @click="selectNote(note)">
            <div style="text-align: right; font-weight: bold;">{{note.Date}}</div>
            <Note :noteData="note" :index="index"></Note>
          </div>
        </v-flex>
      </v-layout>
      <v-layout style="padding: 10px;" v-else>
        <v-flex xs12>
          <div style="font-weight: bold; color: #aaa;">אין נתונים</div>
        </v-flex>
      </v-layout>
    </div>
  </v-app>
</template>

<script>
  import JSZip from 'jszip';
  import FileSaver from 'file-saver';
  //import jsPDF from 'jspdf';
  import SubMenu from '../components/SubMenu';

  import pdfMake from 'pdfmake/build/pdfmake.min.js';
  import pdfFonts from 'pdfmake/build/vfs_fonts.js';
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  import { db, storage } from '../firebase';
  var statusesRef = db.ref('Statuses');
  //var diariesRef = db.ref('Diaries');
  //var projectsRef = db.ref('Projects');

  import yomanetImg from '../assets/yomanet.png';
  import PopupConfim from '../components/PopupConfim';
  import DiaryPage from '../components/DiaryPage';
  import DiaryPageMobile from '../components/DiaryPageMobile';
  import Note from '../components/Note';

  export default {
    name: 'Diary',
    components: { SubMenu, PopupConfim, DiaryPage, DiaryPageMobile, Note },
    data() {
      return {
        txtSearch: '',
        txtAdvanceSearch: '',
        advanceSearchNotes: [],
        advanceSearch: false,
        diary: null,
        project: null,
        pages: [],
        isActiveUsers: false,
        planLink: '',
        popup: {
          isVisible: false,
          title: '',
          question: '',
          caller: '',
          isConfirmed: false,
          data: { '.key': '', Title: '', CustomerName: '', CustomerKey: '', ProjectName: '', ProjectKey: '', CreateDate: '', UpdateDate: '', Info: '', Users: null },
        },
        currentDate: '',
        zip: null,
      }
    },
    firebase: function () {
      var vm = this;
      return {
        statuses: statusesRef.orderByKey()
      }
    },
    created() {
      this.$Log("Vue [Diary] is created ...");
    },
    ready() {
      this.$Log("Vue [Diary] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Diary] is mounted ...");
      this.loadData();
      //this.loadPlanLink();
    },
    updated() {
      this.$Log("Vue [Diary] is updated ...");
    },
    computed: {
      canDownloadDiary() {
        //settings
        var setting = this.$root.settings.find(function (s) {
          return s['.key'] == 'Download';
        });

        if (setting) {
          return setting.KeyValue;
        }
        else {
          return false;
        }
      },
      title() {
        if (this.diary) {
          if (this.diary.Title.length > 20) {
            return this.diary.Title.substring(0, 20) + "...";
          }
          else {
            return this.diary.Title;
          }
        }
        else {
          return '';
        }
      },
      projectName() {
        if (this.diary) {
          return this.diary.ProjectName;
        }
        else {
          return '';
        }
      },
      diaryKey() {
        return this.$route.params.diaryKey;
      },
      hasData() {
        return this.advanceSearchNotes != null && this.advanceSearchNotes != undefined && this.advanceSearchNotes.length > 0;
      },
      weatherInfo() {
        let wth = 'אין נתונים';
        if (this.$root.weather) {
          if (this.$root.weather.currently) {
            wth = this.$root.weather.currently.summary + ' ' + Math.round(this.$root.weather.currently.temperature) + '°';
          }
        }

        return wth;
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveDiary') {
          this.remove();
        }
      },
      advanceSearch(val) {
        this.txtAdvanceSearch = '';
      },
      txtAdvanceSearch(val) {
        this.searchDiary();
      }
    },
    methods: {
      selectNote(note) {
        var vm = this;
        vm.advanceSearch = false;
        for (var i = 0; i < vm.pages.length; i++) {
          if (vm.pages[i].PageKey == note.PageKey) {
            vm.$root.activeDiaryPage = vm.pages[i];
            break;
          }
        }
      },
      searchDiary() {
        var vm = this;
        if (vm.txtAdvanceSearch.length > 2) {
          var txt = String(vm.txtAdvanceSearch);
          try {
            if (vm.pages.length > 0) {
              for (var i = 0; i < vm.pages.length; i++) {
                if (vm.pages[i].PageKey) {
                  var notesPath = 'DiaryPages/' + vm.pages[i].PageKey;// + '/Notes';
                  var notesRef = db.ref(notesPath);

                  notesRef.orderByKey().once('value').then(function (snapshotNotes) {
                    let objArr = snapshotNotes.val();
                    var snapshotKey = snapshotNotes.key;
                    
                    if (objArr && objArr.Notes) {
                      if (Array.isArray(objArr.Notes)) {
                        objArr.Notes.filter(function (row) {
                          if (row.Info.indexOf(txt) > -1 || row.UserFullName.indexOf(txt) > -1) {
                            var exist = vm.advanceSearchNotes.filter(function (nt) {
                              if (nt.Info == row.Info && nt.Date == row.Date) {
                                return nt;
                              }
                            });

                            if (exist.length == 0) {
                              //$root.activeDiaryPage
                              //console.log("snapshotKey >>> " + snapshotKey);
                              row.PageKey = snapshotKey;
                              vm.advanceSearchNotes.push(row);
                            }
                          }
                        });
                      }
                      else {
                        var keys = Object.keys(objArr.Notes);

                        for (var k = 0; k < keys.length; k++) {
                          var row = objArr.Notes[k];
                          if (row) {
                            if (row.Info.indexOf(txt) > -1 || row.UserFullName.indexOf(txt) > -1) {
                              var exist = vm.advanceSearchNotes.filter(function (nt) {
                                if (nt.Info == row.Info && nt.Date == row.Date) {
                                  return nt;
                                }
                              });

                              if (exist.length == 0) {
                                //console.log("snapshotKey >>> " + snapshotKey);
                                row.PageKey = snapshotKey;
                                vm.advanceSearchNotes.push(row);
                              }
                            }
                          }
                        }
                      }
                    }
                  });
                }
              }
            }
          }
          catch (e) {
          }
        }
        else {
          //result = vm.diaries;
          vm.advanceSearchNotes = [];
        }
      },
      sendMail(page, event) {
        var vm = this;
        var docWeather = "מזג אויר";
        var weatherPath = 'DiaryPages/' + page.PageKey + '/Weather';
        var weatherRef = db.ref(weatherPath);
        weatherRef.orderByKey().once('value').then(function (snapWeather) {
          let objWeather = snapWeather.val();
          vm.downloadOrSendPageWithWeather(vm, true, objWeather, page, event);
        });
      },
      downloadPage(page, event) {
        var vm = this;
        var docWeather = "מזג אויר";
        var weatherPath = 'DiaryPages/' + page.PageKey + '/Weather';
        var weatherRef = db.ref(weatherPath);
        weatherRef.orderByKey().once('value').then(function (snapWeather) {
          let objWeather = snapWeather.val();
          vm.downloadOrSendPageWithWeather(vm, false, objWeather, page, event);
        });
      },
      downloadOrSendPageWithWeather(vm, isSend, weather, page, event) {
        //var vm = this;

        event.stopPropagation();

        vm.zip = new JSZip();
        var dateFolder = page.Date.replace("/", ".").replace("/", ".");
        var zipFilename = dateFolder + ".zip";
        var zipFolder = vm.zip.folder(dateFolder);
        var pdfFilename = "דף יומן " + dateFolder + ".pdf";

        //http://pdfmake.org/index.html#/gettingstarted

        var fonts = {
          Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
          },
          Hebrew: {
            normal: 'Narkis-Hebrew',
            bold: 'Narkis-Hebrew',
            italics: 'Narkis-Hebrew',
            bolditalics: 'Narkis-Hebrew',
          },
          Arabic: {
            normal: 'Amiri-Arabic-Regular.ttf',
            bold: 'Amiri-Arabic-Regular.ttf',
            italics: 'Amiri-Arabic-Regular.ttf',
            bolditalics: 'Amiri-Arabic-Regular.ttf'
          }
        };

        pdfMake.fonts = fonts;

        var nbspace = " "; // nbspace char (alt + 255)
        var specialChar = "∞"; // specialChar char (alt + 236)∞
        var arbText = 'إذا لم تستح فاصنع ما شئت';
        //aText = aText.split(" ").reverse().join(nbspace);
        arbText = arbText.split(" ").join(nbspace);
        //aText = aText.replace(" ", nbspace);

        var docTitle = "דף יומן ";
        docTitle = docTitle.split(" ").join(nbspace);

        
        //var weatherPath = 'DiaryPages/' + page.PageKey + '/Weather';
        //var weatherRef = db.ref(weatherPath);
        //var weatherLoaded = false;
        //weatherRef.orderByKey().once('value').then(function (snapWeather) {
        //  let objWeather = snapWeather.val();
        //  docWeather = docWeather.split(" ").join(nbspace);
        //  docWeather = "(" + docWeather + ": " + objWeather + ")";
        //  alert(docWeather);
        //  weatherLoaded = true;
        //});

        //alert(docWeather);
        //docWeather = docWeather.split(" ").join(nbspace);
        var docWeather = "מזג אויר";
        docWeather = "(" + docWeather + ": " + weather + ")";
        docWeather = vm.replaceChars(docWeather);
        docWeather = vm.reverseEnglish(docWeather);
        docWeather = vm.reverseChars(docWeather);
        docWeather = docWeather.split(" ").join(nbspace);

        var docProject = "פרויקט";
        docProject = "(" + docProject + ": " + vm.diary.ProjectName + ")";
        docProject = vm.replaceChars(docProject);
        docProject = vm.reverseEnglish(docProject);
        docProject = vm.reverseChars(docProject);
        docProject = docProject.split(" ").join(nbspace);
        
        var customerName = vm.diary.CustomerName.split(" ").join(nbspace);
        var imgBase64 = "";
        var img = document.getElementById('imgYoman');
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        imgBase64 = dataURL;

        var docDefinition = {
          header: {
            columns: [
              page.Date,
              { text: customerName, alignment: 'right' }
            ],
            margin: 10
          },
          content: [
            {
              image: 'yomanetImg',
              width: 50,
              alignment: 'center',
            },
            {
              text: docTitle,
              alignment: 'center',
              margin: 5,
              fontSize: 24
            },
            {
              text: page.Date,
              alignment: 'center',
              margin: 5,
              fontSize: 24
            },
            {
              text: docProject,
              alignment: 'center',
              margin: 5,
              color: '#555'
            },
            {
              text: docWeather,
              alignment: 'center',
              margin: 5,
              color: '#555'
            }
          ],
          images: {
            yomanetImg: imgBase64
          },

          defaultStyle: {
            font: 'Hebrew'
          },

          styles: {
            header: {
              font: 'Arabic',
              fontSize: 22,
              bold: true
            },
            anotherStyle: {
              alignment: 'right'
            },
            arabic: {
              font: 'Arabic',
              fontSize: 18,
              alignment: 'right'
            },
          }
        };

        var notesPath = 'DiaryPages/' + page.PageKey + '/Notes';
        var notesRef = db.ref(notesPath);

        var notes = [];
        var notesGeneral = [];
        var notesInfo = [];
        var notesInspector = [];
        var notesContractor = [];
        var files = [];

        notesRef.orderByKey().once('value').then(function (snapNotes) {
          let objNotes = snapNotes.val();
          if (objNotes) {
            let keys = Object.keys(objNotes);
            let zipAdded = 0;
            let attachCount = 0;
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i];
              let objNote = objNotes[key];

              var auther = objNote.UserFullName + " )" + objNote.UserType + "(:";
              auther = auther.split(" ").join(nbspace) + "  " + objNote.Time;

              var info = objNote.Info;
              info = vm.replaceChars(info);
              info = vm.reverseEnglish(info);
              info = vm.reverseDate(info);
              info = vm.reverseChars(info);
              info = info.split(" ").join(nbspace);
              
              //notes.push({ text: auther.split(" ").join(nbspace) + "  " + objNote.Time, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
              notes.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
              //notes.push({ text: auther, alignment: 'right', color: '#555' });


              //notes.push({ text: objNote.Info.split(" ").join(nbspace), alignment: 'right', margin: 5 });
              notes.push({ text: info, alignment: 'right', margin: 5 });
              //notes.push({ text: info, alignment: 'right' });

              if (objNote.IsGeneral) {
                //notesGeneral.push(notes);
                notesGeneral.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
                notesGeneral.push({ text: info, alignment: 'right', margin: 5 });
              }
              else if (objNote.IsInfo) {
                //notesInfo.push(notes);
                notesInfo.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
                notesInfo.push({ text: info, alignment: 'right', margin: 5 });
              }
              else {
                if (objNote.UserType == 'מפקח') {
                  //notesInspector.push(notes);
                  notesInspector.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
                  notesInspector.push({ text: info, alignment: 'right', margin: 5 });
                }
                else if (objNote.UserType == 'מנהל עבודה') {
                  //notesContractor.push(notes);
                  notesContractor.push({ text: auther, alignment: 'right', color: '#555', margin: [0, 10, 0, 0] });
                  notesContractor.push({ text: info, alignment: 'right', margin: 5 });
                }
              }

              //notes = [];

              if (objNote.Attachments) {
                //notes.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
                if (objNote.IsGeneral) {
                  notesGeneral.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
                }
                else if (objNote.IsInfo) {
                  notesInfo.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
                }
                else {
                  if (objNote.UserType == 'מפקח') {
                    notesInspector.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
                  }
                  else if (objNote.UserType == 'מנהל עבודה') {
                    notesContractor.push({ text: "קבצים מצורפים:".split(" ").join(nbspace), alignment: 'right' });
                  }
                }
                let attachKeys = Object.keys(objNote.Attachments);
                attachCount += attachKeys.length;
                for (let a = 0; a < attachKeys.length; a++) {
                  let attachKey = attachKeys[a];
                  let fileUrl = objNote.Attachments[attachKey].FileUrl;
                  let fileName = objNote.Attachments[attachKey].FileName;

                  files.push({ fileUrl: fileUrl, fileName: fileName });

                  //notes.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });

                  if (objNote.IsGeneral) {
                    //notesGeneral.push(notes);
                    notesGeneral.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });
                  }
                  else if (objNote.IsInfo) {
                    //notesInfo.push(notes);
                    notesInfo.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });
                  }
                  else {
                    if (objNote.UserType == 'מפקח') {
                      //notesInspector.push(notes);
                      notesInspector.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });
                    }
                    else if (objNote.UserType == 'מנהל עבודה') {
                      //notesContractor.push(notes);
                      notesContractor.push({ text: fileName, link: fileName, decoration: "underline", fontSize: 12, color: 'blue', alignment: 'right' });
                    }
                  }
                  //notes = [];
                }
              }
            }

            docDefinition.content.push({ text: "הערות כלליות:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', margin: [20, 20, 0, 20] });
            docDefinition.content.push(notesGeneral);

            docDefinition.content.push({ text: "תיאור עבודה:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', margin: [20, 20, 0, 20] });
            docDefinition.content.push(notesInfo);

            //docDefinition.content.push({
            //  columns: [
            //    { text: "הערות מפקח:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', border: [false, true, false, false], margin: [20, 20, 0, 20] },
            //    { text: "הערות מנהל עבודה:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', margin: [20, 20, 0, 20] }
            //  ]
            //});

            var tableBody = [];

            tableBody.push([
              { text: "הערות מפקח:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', border: [false, true, false, false], margin: [20, 20, 0, 20] },
              { text: "הערות מנהל עבודה:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', margin: [20, 20, 0, 20] }
            ]);

            var lenInspector = notesInspector.length;
            var lenContractor = notesContractor.length;
            var max = 0;

            max = lenContractor;
            if (lenInspector >= lenContractor) { max = lenInspector }

            for (var m = 0; m < max; m++) {
              tableBody.push([
                notesInspector[m] ? notesInspector[m] : " ",
                notesContractor[m] ? notesContractor[m] : " "
              ]);
            }

            var table = {
              table: {
                widths: [250, 250],
                headerRows: 1,
                body: tableBody
                //body: [
                //  [
                //    { text: "הערות מפקח:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', border: [false, true, false, false], margin: [20, 20, 0, 20] },
                //    { text: "הערות מנהל עבודה:".split(" ").join(nbspace), decoration: "underline", fontSize: 16, alignment: 'right', margin: [20, 20, 0, 20] }
                //  ],
                //  ['Sample value 1', 'Sample value 2'],
                //  ['Sample value 1', 'Sample value 2'],
                //  ['Sample value 1', 'Sample value 2'],
                //  ['Sample value 1', 'Sample value 2'],
                //  ['Sample value 1', 'Sample value 2'],
                //]
              },
              layout: 'noBorders'
            };

            docDefinition.content.push(table);

            //for (var m = 0; m < max; m++) {

            //  docDefinition.content.push({
            //    columns: [
            //      notesInspector[m] ? notesInspector[m] : " ",
            //      notesContractor[m] ? notesContractor[m] : " "
            //    ]
            //  });
            //}

            console.log(JSON.stringify(notesInspector))

            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getBlob((blob) => {

              if (isSend) {
                vm.uploadPDF(pdfFilename, blob, function (pdfUrl) {
                  var pdfTitle = "דף יומן " + dateFolder;
                  console.log(pdfUrl);
                  vm.sendToMail(vm, page, pdfTitle, pdfUrl)
                  return;
                });
              }

              zipFolder.file(pdfFilename, blob, { binary: true });

              if (files.length > 0) {
                for (var fl = 0; fl < files.length; fl++) {

                  var url = files[fl].fileUrl;
                  var name = files[fl].fileName;

                  vm.getBinaryFile(files[fl], function (data, file) {
                    zipFolder.file(file.fileName, data, { binary: true });
                    zipAdded++;
                    if (zipAdded == attachCount) {
                      vm.zip.generateAsync({ type: "blob" }).then(function (content) {
                        FileSaver.saveAs(content, zipFilename);
                      });
                    }
                  });
                }
              }
              else {
                if (zipAdded == attachCount) {
                  vm.zip.generateAsync({ type: "blob" }).then(function (content) {
                    FileSaver.saveAs(content, zipFilename);
                  });
                }
              }
            });
          }
        });
      },
      getBinaryFile(file, callback) {
        JSZipUtils.getBinaryContent(file.fileUrl, function (err, data) {
          if (!err) {
            callback(data, file);
          }
          else {
            console.log("Added file Error: " + err);
          }
        });
      },
      replaceChars(txt) {
        var chars = "*=+:\n°";
        var newTxt = "";
        var arr = txt.split('');
        for (var i = 0; i < arr.length; i++) {
          var index = -1;
          var chr = arr[i];
          index = chars.indexOf(arr[i]);
          if (index >= 0) {
            chr = " " + chr + " ";
          }

          newTxt = newTxt + chr;
        }
        return newTxt;
      },
      reverseEnglish(txt) {
        var english = /^[A-Za-z0-9/\\:]*$/;
        //var ENGLISH = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        var arr = txt.split(" ");
        for (var i = 0; i < arr.length; i++) {
          if (english.test(arr[i])) {
            console.log(arr[i])
            arr[i] = arr[i].split("").reverse().join("");
          }
        }
        txt = arr.join(" ");
        return txt;
      },
      reverseDate(txt) {
        var dateReg = /(\d{4}([.\-/ ])\d{2}\2\d{2}|\d{2}([.\-/ ])\d{2}\3\d{4})/;
        var arr = txt.split(" ");
        for (var i = 0; i < arr.length; i++) {
          if (dateReg.test(arr[i])) {
            arr[i] = arr[i].split("").reverse().join("");
          }
        }
        txt = arr.join(" ");
        return txt;
      },
      reverseChars(txt) {
        var tmpCharL = "δ"; //(alt + 235)
        var tmpCharR = "∞"; //(alt + 236)
        var left = "({[";
        var right = ")}]";

        var arr = txt.split("");
        for (var i = 0; i < arr.length; i++) {
          var index = -1;
          index = left.indexOf(arr[i]);
          if (index >= 0) {
            arr[i] = " " + right[index] + " " ;
          }
          else {
            index = right.indexOf(arr[i]);
            if (index >= 0) {
              arr[i] = " " + left[index] + " ";
            }
          }
        }
        txt = arr.join("");
        return txt;
      },
      loadData() {
        var vm = this;
        console.log('[Diary].loadData() ...');
        var diaryRef = db.ref('Diaries/' + vm.$route.params.diaryKey).once('value').then(function (snapDiary) {

          vm.diary = snapDiary.val();
          vm.diary['.key'] = vm.$route.params.diaryKey;
          console.log(vm.diary);
          var projectRef = db.ref('Projects/' + vm.diary.ProjectKey).once('value').then(function (snapProject) {

            let prj = snapProject.val();
            if (prj) {
              vm.project = prj;
              vm.project['.key'] = vm.diary.ProjectKey;
            }
            else {
              vm.project = {
                Name: 'לא קיים!!',
                City: '',
                Address: '',
                Location: { lat: 0, lng: 0 },
                Info: '',
                StatusKey: '',
                UserKey: '',
                Active: '',
                Images: '',
                CreateDate: '',
                UpdateDate: '',
                StartDate: '',
                EndDate: '',
              };
              vm.project['.key'] = vm.diary.ProjectKey;
            }

            vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.project.Location.lat, vm.project.Location.lng, function (error, data) {
              if (error) {
                console.log('vm.$GetWeather() Error: ')
                console.log(error)
                //vm.$root.weather = 'No Data';

                vm.$root.weather = {
                  currently: {
                    time: 0,
                    summary: 'No Data',
                    temperature: 0
                  }
                };
                vm.currentDate = vm.$moment().format('DD/MM/YYYY');
              }
              if (!error) {
                console.log('vm.$GetWeather() Data: ')
                console.log(data)
                vm.$root.weather = data;
                //vm.currentDate = vm.$moment(vm.$root.weather.currently.time * 1000).format('DD/MM/YYYY');
                vm.currentDate = vm.$moment().format('DD/MM/YYYY');
              }
              //if (!error) {
              if (true) {
                vm.pages = [];
                console.log(vm.currentDate);
                console.log(vm.diary.Pages);

                if (vm.diary.Pages) {
                  let keysPg = Object.keys(vm.diary.Pages);
                  keysPg.forEach(function (key) {
                    vm.pages.push(vm.diary.Pages[key]);
                  });
                }

                if (vm.pages.length > 0) {
                  var len = vm.pages.length;
                  if (vm.pages[len - 1].Date != vm.currentDate) {
                    vm.pages.push({ PageKey: null, Date: vm.currentDate, Weather: vm.weatherInfo });
                  }
                  vm.pages = vm.pages.reverse();
                }
                else {
                  vm.pages.push({ PageKey: null, Date: vm.currentDate, Weather: vm.weatherInfo });
                }

                if (vm.$root.activeDiaryPage.PageKey == null) {
                  vm.$root.activeDiaryPage = vm.pages[0];
                }

                var plansRef = db.ref('Plans').orderByChild("ProjectKey").equalTo(vm.project['.key']).once('value').then(function (snapPlan) {
                  var obj = snapPlan.val();
                  if (obj) {
                    let planKey = Object.keys(obj)[0];
                    vm.planLink = '/#/Plan/' + planKey;
                  }
                  else {
                    vm.planLink = '';
                  }
                });

              }
            });
          }).catch(function (errorProject) {
            console.log('Project Error: ');
            console.log(errorProject);
          });
        }).catch(function (errorDiary) {
          console.log('Diary Error: ');
          console.log(errorDiary);
        });
      },
      loadPlanLink() {
        // url >>> /#/Plan/-L8akbfLtf24sGHwEHTK
        var vm = this;
        var plansRef = db.ref('Plans').orderByChild("ProjectKey").equalTo(vm.project['.key']).once('value').then(function (snapPlan) {
          var obj = snapPlan.val();
          if (obj) {
            let planKey = Object.keys(obj)[0];
            vm.planLink = '/#/Plan/' + planKey;
          }
        });
      },
      getStatus() {
        var vm = this;

        if (vm.project) {
          var status = vm.statuses.find(function (st) {
            return st['.key'] == vm.project.StatusKey
          });

          if (status) {
            return status.Name;
          }
        }

        return '';
      },
      getPlanUrl() {

      },
      dayClick(page) {
        //alert(day);
        this.selectedDate = page.Date;
        this.$root.activeDiaryPage = page;
        this.loadData();
      },
      addNew() {
        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'יומן חדש',
          data: { '.key': '', Title: '', CustomerName: '', CustomerKey: '', ProjectName: '', ProjectKey: '', CreateDate: '', UpdateDate: '', Info: '', Users: null },
        };
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת יומן',
          data: {
            '.key': row['.key'],
            Title: row.FullName,
            CustomerName: row.ContactPerson,
            CustomerKey: row.Phone,
            ProjectName: row.Username,
            ProjectKey: row.Password,
            CreateDate: row.TotalDiaries,
            UpdateDate: row.UsedDiaries,
            Info: row.Info,
            Users: row.Users
          }
        };
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemoveUser',
          isConfirmed: false
        }
      },
      remove() {
        diariesRef.child(this.popup.data['.key']).remove();
      },
      insert() {
        var item = {
          Title: this.popup.data.FullName,
          CustomerName: this.popup.data.ContactPerson,
          CustomerKey: this.popup.data.Phone,
          ProjectName: this.popup.data.Username,
          ProjectKey: this.popup.data.Password,
          CreateDate: this.popup.data.TotalDiaries,
          UpdateDate: this.popup.data.UsedDiaries,
          Info: this.popup.data.Info,
          Users: this.popup.data.Users
        };

        diariesRef.push(item);
      },
      update() {
        var item = {
          Title: this.popup.data.FullName,
          CustomerName: this.popup.data.ContactPerson,
          CustomerKey: this.popup.data.Phone,
          ProjectName: this.popup.data.Username,
          ProjectKey: this.popup.data.Password,
          CreateDate: this.popup.data.TotalDiaries,
          UpdateDate: this.popup.data.UsedDiaries,
          Info: this.popup.data.Info,
          Users: this.popup.data.Users
        };
        diariesRef.child(this.popup.data['.key']).set(item);
      },
      sendToMail(vm, page, pdfTitle, pdfUrl) {
        console.log('Share.sendMail()');
        console.log(pdfTitle);
        console.log(pdfUrl);
        var pdfUrlPath = 'DiaryPages/' + page.PageKey + '/PdfUrl';
        console.log(pdfUrlPath);
        db.ref(pdfUrlPath).set(pdfUrl);

        pdfUrl = encodeURIComponent(pdfUrl);

        let title = ' יומנט  ' + pdfTitle;
        let subject = title;
        let body = '';
        let newLine = '%0D%0A';

        body += ' שלום רב,';
        body += newLine;
        body += newLine;

        body += title + ' : ';
        body += newLine;
        body += newLine;

        body += pdfUrl;
        //body += 'https://a-h-btehot.web.app/PdfView/' + report.RowID;
        body += newLine;
        body += newLine;
        body += newLine;

        body += 'בברכה,';
        body += 'יומנט';
        body += newLine;
        body += newLine;
        body += newLine;

        console.log(body);

        let sendTo = vm.$root.user.Username;

        let command = 'mailto:' + sendTo + '?subject=' + subject + '&body=' + body;

        if (sendTo && sendTo.length > 0) {
          command = 'mailto:' + sendTo + '?subject=' + subject + '&body=' + body;
          console.log(command);
          window.location = command;
        } else {
          alert('חסר כתובת מייל לשליחה !!')
        }
      },
      uploadPDF(pdfFilename, blob, callback) {
        //let fileName = row.Customer.FullName
        let storageRef = storage.ref('Diary/' + pdfFilename);

        let task = storageRef.put(blob);
        let percent = 0;
        task.on('state_changed',
          function progress(snap) {
            console.log("bytesTransferred = " + snap.bytesTransferred + ' of ' + snap.totalBytes);
            percent = (snap.bytesTransferred / snap.totalBytes) * 100;
            console.log("percent = " + percent + ' %');
            console.log("percent = " + Math.floor(percent) + ' %');
            //vm.$root.isLoadingMsg = 'שומר קובץ ...' + Math.floor(percent) + ' %';
          },
          function error(err) {
          },
          function complete() {
            console.log("Upload Completed !");

            task.snapshot.ref.getDownloadURL().then((downloadURL) => {
              console.log('File available at', downloadURL);
               callback(downloadURL);
            });

            //console.log(task.snapshot.downloadURL);
            // console.log(task.snapshot);
            //vm.$root.isLoadingMsg = 'קובץ PDF נשמר בהצלחה...';
            //callback(task.snapshot.downloadURL);
          }
        );
      }
    }
  }

</script>
<style>
  .advanceSearch {
    position: absolute;
    top: 20px;
    bottom: 20px;
    right: 20px;
    left: 20px;
    z-index: 20000;
    background-color: #eee;
  }


  .btnPlans {
    color: blue;
    color: #fff;
    display: block;
    cursor: pointer;
    background-color: #F7941D;
    border-radius: 5px;
    margin: 5px;
    padding: 2px;
    font-size: 16px;
  }

  .divDiary {
    width: 400px;
    text-align: right;
    padding-right: 10px;
    float: right;
  }

  .logoDiary {
    width: 70px;
    height: 70px;
    float: right;
  }

  .diaryTitle {
    padding-right: 10px;
    line-height: 70px;
    font-size: 30px;
    float: right;
  }

  .divScroll {
    position: absolute;
    top: 80px;
    right: 5px;
    left: 0px;
    bottom: 0px;
    overflow-y: scroll;
  }

  .divScrollMobile {
    position: absolute;
    top: 80px;
    right: 5px;
    left: 5px;
    bottom: 5px;
    overflow-y: scroll;
  }

  .fe_forecast{

  }

    .fe_forecast > div.fe_currently {
    }

  #fe_current_icon {
    width: 30px !important;
    height: 30px !important;
  }
  .fe_temp {
    font-size: 20px !important;
  }
  .fe_dir {
    display: none;
  }
  .fe_forecast > div.fe_currently > div.fe_temp {
  }

    .fe_forecast > div.fe_daily {
      display: none;
    }
  .fe_summary {
    display: none;
  }
  .fe_wind {
    display: none;
  }


  .list__tile__action--stack {
    flex-direction: row;
  }

</style>



// WEBPACK FOOTER //
// Diary.vue?4e3308f7